'use strict';
import forEach from 'lodash/forEach';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Component} from 'react';
import {getChannelSelectorTarget} from '../../utils';
import {ChatMessageInputView} from './ChatMessageInputView';

export class ChatMessageInputComponent extends Component {
  static propTypes = {
    className: T.string,
    disabled: T.bool,
    maxLength: T.number,
    channel: T.object,
    onCalloutButtonClick: T.func.isRequired,
    onSubmit: T.func.isRequired,
  };

  static defaultProps = {
    maxLength: 2048,
    channel: {}, // only valid when disabled
  };

  static $inject = [
    'selectorsService',
  ];

  constructor(props) {
    super(props);
    this.state = {
      characterCount: 0,
      callouts: {},
    };
    this.setInput = this.setInput.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleClickSubmit = this.handleClickSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCalloutButtonClick = this.handleCalloutButtonClick.bind(this);
  }

  setInput(input) {
    this.input = input;
  }

  handleClick(e) {
    e.stopPropagation();
    if (this.input) {
      this.input.focus();
    }
  }

  handleKeyPress(e) {
    if (e.nativeEvent.keyCode === 13 && !e.nativeEvent.shiftKey) {
      e.preventDefault();
      this.handleSubmit();
    }
  }

  handleClickSubmit(e) {
    e.stopPropagation();
    e.preventDefault();
    this.handleSubmit();
  }

  handleSubmit() {
    if (this.input && this.input.value && isFunction(this.props.onSubmit)) {
      const message = this.input.value;
      const callouts = getValidCallouts(message, this.state.callouts);

      this.props.onSubmit(message, callouts);
      this.input.value = '';

      this.setState({
        characterCount: 0,
        callouts: {},
      });
    }
  }

  handleChange(e) {
    const message = e.target.value;
    this.setState({
      characterCount: message.length,
    });
  }

  handleCalloutButtonClick(e) {
    e.stopPropagation();
    // TODO: add the chat channel data as the target
    ChatMessageInputComponent.dependencies.selectorsService
      .selectPersonnelRedux({
        useSimple: true,
        selected: void 0,
        exclusions: {
          nonUsers: true,
        },
        ...getChannelSelectorTarget(this.props.channel),
      })
      .then(selected => {
        if (selected && !this.isUnmounted && this.input) {
          const name = /* selected.name.includes(' ') ? `@[${selected.name}]` :*/ `@${selected.name}`;
          this.input.value += name;
          this.setState({
            callouts: {
              ...(this.state.callouts || {}),
              [name]: {
                token: name,
                id: selected.id,
                collection: selected.collection,
              },
            },
          });
          this.input.focus();
        }
      })
      .catch(noop);
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  render() {
    const props = this.props;
    return (
      <ChatMessageInputView
        className={props.className}
        style={props.style}
        disabled={props.disabled}
        characterCount={this.state.characterCount}
        maxLength={props.maxLength}
        setInputRef={this.setInput}
        onClick={this.handleClick}
        onKeyPress={this.handleKeyPress}
        onChange={this.handleChange}
        onCalloutButtonClick={this.handleCalloutButtonClick}
        onClickSubmit={this.handleClickSubmit}
      />
    );
  }
}

function getValidCallouts(message, callouts) {
  const verified = [];
  forEach(callouts, (callout, key) => {
    const idx = message.indexOf(key);
    if (idx > -1) {
      verified.push({
        ...callout,
        idx,
      });
    }
  });
  return verified;
}



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatMessageInput/ChatMessageInputComponent.js